import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["title"]

import { computed } from 'vue';
import usePWAInstall from '@/composables/usePWAInstall';
import useModals from '@/components/Modals/useModals';
import { EModal } from '@/enums';


export default /*@__PURE__*/_defineComponent({
  __name: 'PWAInstallButton',
  setup(__props) {

const { platform, shouldShowInstallButton, showInstallPrompt } = usePWAInstall();
const { toggleModal } = useModals();

const installButtonTitle = computed(() => {
  if (platform.value === 'ios') {
    return 'Adicionar à tela inicial';
  }
  return 'Instalar aplicativo';
});

const handleInstallClick = async () => {
  // Para iOS, mostra o modal com instruções
  if (platform.value === 'ios') {
    toggleModal(EModal.pwa_install);
    return;
  }

  // Para Android/Desktop, mostra o prompt nativo
  const installed = await showInstallPrompt();

  if (installed) {
    console.log('📱 PWA: App will be installed');
  }
};

return (_ctx: any,_cache: any) => {
  return (_unref(shouldShowInstallButton)())
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        onClick: handleInstallClick,
        class: "btn btn-sm btn-primary d-flex align-items-center pwa-btn pwa-install-container",
        title: installButtonTitle.value
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("i", { class: "fas fa-download pwa-icon" }, null, -1),
        _createElementVNode("span", { class: "pwa-text" }, "Instalar App", -1)
      ]), 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})